import {
  RoomId,
  roomId,
  RoomIsRecording,
  roomIsRecording
} from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomRecordingDeleteCmd {
  private static validation = JsonSchemaValidator.compile(
    RoomRecordingDeleteCmd.validationSchema()
  );

  constructor(readonly value: RoomRecordingDelete) {
    JsonSchemaValidator.assert(RoomRecordingDeleteCmd.validation, value);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "roomIsRecording"],
      properties: {
        roomId,
        roomIsRecording
      }
    };
  }
}

interface RoomRecordingDelete {
  roomId: RoomId;
  roomIsRecording: RoomIsRecording;
}
